import React from 'react';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  apiKey: string;
  setApiKey: (key: string) => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose, apiKey, setApiKey }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Settings</h3>
          <button onClick={onClose} className="close-btn">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="modal-body">
          <p className="settings-info">
            Enter your Google Gemini API Key to enable AI-powered YAML to Mermaid conversion.
          </p>
          <label htmlFor="api-key">Gemini API Key</label>
          <input
            id="api-key"
            type="password"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="AIzaSy..."
            className="api-key-input"
          />
          <p className="settings-note">
            Your API key is stored in session storage and never sent to our servers.
          </p>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="btn-primary">Save</button>
        </div>
      </div>
    </div>
  );
};
